import React from "react";

export default function PageHeader({
  eyebrow,
  title,
  description,
  align = "left",
  testId,
}) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div
      data-testid={testId || "page-header"}
      className={`max-w-3xl ${alignCls} mb-14 fade-in`}
    >
      {eyebrow && (
        <div
          data-testid="page-header-eyebrow"
          className="inline-flex items-center gap-2 mb-4 text-[11px] tracking-[0.32em] uppercase text-emerald-400/80"
        >
          <span className="w-6 h-px bg-emerald-400/40" />
          {eyebrow}
        </div>
      )}
      <h1
        data-testid="page-header-title"
        className="text-4xl sm:text-5xl lg:text-6xl font-extralight tracking-tight text-white leading-[1.05]"
      >
        {title}
      </h1>
      {description && (
        <p
          data-testid="page-header-description"
          className="mt-5 text-base sm:text-lg font-light text-white/50 leading-relaxed max-w-2xl"
        >
          {description}
        </p>
      )}
    </div>
  );
}
